export const PostStart = () => {
    if (window.location.pathname.includes('editor')) {
        return (
            <div style={{
                borderTop: '2px solid #ccc',
                padding: '8px 0',
                margin: '16px 0',
                textAlign: 'center',
                color: '#666',
                fontSize: '12px'
            }}>
                Post Start
            </div>
        );
    }
    return null;
};

export default PostStart;